import React from 'react';

export interface BoardSelectorProps {
  boards: { id: string; name: string; createdAt: number; updatedAt: number }[];
  activeBoardId: string;
  onSelect: (id: string) => void;
  onNew: () => void;
  onRename: () => void;
  onDelete: () => void;
}

export const BoardSelector: React.FC<BoardSelectorProps> = ({ boards, activeBoardId, onSelect, onNew, onRename, onDelete }) => {
  return (
    <div className="flex items-center gap-2 mb-4">
      <select
        className="border rounded px-2 py-1"
        value={activeBoardId}
        onChange={e => onSelect(e.target.value)}
      >
        {boards.map(board => (
          <option key={board.id} value={board.id}>{board.name}</option>
        ))}
      </select>
      <button className="btn btn-xs" onClick={onNew}>+ New Board</button>
      <button className="btn btn-xs" onClick={onRename}>Rename</button>
      <button className="btn btn-xs" onClick={onDelete}>Delete</button>
    </div>
  );
}; 